export function getTotalPages(data: unknown): number {
  if (!data || typeof data !== 'object') return 1;
  const d = data as Record<string, unknown>;
  const fromObj = (obj: unknown): number | null => {
    if (!obj || typeof obj !== 'object') return null;
    const p = obj as Record<string, unknown>;
    const n = Number(p.pagesCount ?? p.pageCount ?? p.page_count ?? p.total_pages);
    if (Number.isFinite(n) && n > 0) return n;
    const fromTotals = Math.ceil(Number(p.totalCount) / Number(p.pageSize));
    return Number.isFinite(fromTotals) && fromTotals > 0 ? fromTotals : null;
  };
  return (
    fromObj(d.pagination) ??
    fromObj(d.pages) ??
    (typeof d.pagesCount === 'number' ? d.pagesCount : null) ??
    1
  );
}

export function getListRows<T extends Record<string, unknown>>(
  data: unknown,
  keys: string[] = ['items', 'users', 'list', 'data'],
): T[] {
  if (!data || typeof data !== 'object') return [];
  const d = data as Record<string, unknown>;
  for (const key of keys) {
    const val = d[key];
    if (Array.isArray(val)) return val as T[];
    if (val && typeof val === 'object') return Object.values(val) as T[];
  }
  return [];
}
